enum QBDQueueActionEnum {
    READ_CUSTOMERS = "READ_CUSTOMERS",
    READ_PRODUCTS = "READ_PRODUCTS",
    READ_TERMS = "READ_TERMS",
    READ_SALES_TAX_OPTIONS = "READ_SALES_TAX_OPTIONS",
    READ_SALES_TAX_ITEMS = "READ_SALES_TAX_ITEMS",
    READ_COGS_ACCOUNT_OPTIONS = "READ_COGS_ACCOUNT_OPTIONS",
    READ_ASSET_ACCOUNT_OPTIONS = "READ_ASSET_ACCOUNT_OPTIONS",
    READ_INCOME_ACCOUNT_OPTIONS = "READ_INCOME_ACCOUNT_OPTIONS",
    READ_TEMPLATES = "READ_TEMPLATES",
    READ_SALES_REPS = "READ_SALES_REPS",
    READ_ITEM_SUBTOTALS = "READ_ITEM_SUBTOTALS",
    READ_PRICE_LEVELS = "READ_PRICE_LEVELS",
    READ_UNIT_OF_MEASURE = "READ_UNIT_OF_MEASURE",
    READ_ITEM_SITES = "READ_ITEM_SITES",
    READ_CLASS = "READ_CLASS",
    READ_SHIP_METHOD = "READ_SHIP_METHOD",
    READ_INVENTORY_SITE_LIST = "READ_INVENTORY_SITE_LIST",
    READ_INVOICES = "READ_INVOICES",
    READ_SALES_ORDERS = "READ_SALES_ORDERS",
    READ_VENDORS = "READ_VENDORS",
    READ_PURCHASE_ORDERS = "READ_PURCHASE_ORDERS",
    READ_DATA_EXT_DEFS = "READ_DATA_EXT_DEFS",

    CREATE_SALES_ORDER = "CREATE_SALES_ORDER",
    CREATE_INVOICE = "CREATE_INVOICE",
    CREATE_CUSTOMER = "CREATE_CUSTOMER",
    CREATE_CATALOG_ITEM = "CREATE_CATALOG_ITEM",
    CREATE_GROUPED_INVOICE = "CREATE_GROUPED_INVOICE",
    CREATE_PURCHASE_ORDER = "CREATE_PURCHASE_ORDER",
}

export default QBDQueueActionEnum;
